import {
  loadTenantHostConfig,
  tenantHostForSlugWithConfig,
  tenantSlugFromHostWithConfig,
} from '@api-common/tenant-host-config';

function viteEnv(): Record<string, string | undefined> {
  const e = import.meta.env;
  return {
    TENANT_DOMAIN_SUFFIX: e.VITE_TENANT_DOMAIN_SUFFIX as string | undefined,
    TENANT_RESERVED_SUBDOMAINS: e.VITE_TENANT_RESERVED_SUBDOMAINS as string | undefined,
    TENANT_DEMO_HOST: e.VITE_TENANT_DEMO_HOST as string | undefined,
    TENANT_DEMO_SLUG: e.VITE_TENANT_DEMO_SLUG as string | undefined,
  };
}

const cfg = () => loadTenantHostConfig(viteEnv());

export const DEMO_TENANT_HOST =
  import.meta.env.VITE_TENANT_DEMO_HOST ?? 'talent.gyx.ireborn.com.cn';
export const TENANT_DOMAIN_SUFFIX =
  import.meta.env.VITE_TENANT_DOMAIN_SUFFIX ?? '.gyx.ireborn.com.cn';

export function tenantSlugFromHost(host?: string | null): string | null {
  const h =
    host ??
    (typeof window !== 'undefined' ? window.location.hostname : '');
  return tenantSlugFromHostWithConfig(h, cfg());
}

export function tenantHostForSlug(slug: string): string {
  return tenantHostForSlugWithConfig(slug, cfg());
}
